<template>
  <div
    class="collapse-height"
    :class="{ 'collapse-height--opened': isOpened }">
    <div
      class="collapse-height__toggler"
      @click="toggleCollapse(!isOpened)">
      <slot
        name="toggler"
        v-bind="{ isOpened }" />
    </div>

    <div class="collapse-height__wrapper">
      <transition-collapse-height>
        <div
          v-show="isOpened || !isActive"
          class="collapse-height__content">
          <slot name="content" />
        </div>
      </transition-collapse-height>
    </div>
  </div>
</template>

<script>
import TransitionCollapseHeight from 'Components/ui/CollapseHeight/TransitionCollapseHeight.vue';

export default {
  name: 'CollapseHeight',

  components: {
    TransitionCollapseHeight,
  },

  props: {
    isActive: {
      type: Boolean,
      default: true,
    },

    defaultState: {
      type: String,
      default: 'closed',
      validator: (value) => ['opened', 'closed'].includes(value),
    },
  },

  data() {
    return {
      isOpened: this.defaultState === 'opened',
    };
  },

  methods: {
    toggleCollapse(state) {
      if (!this.isActive) {
        return;
      }

      this.isOpened = state;
      this.$emit('toggle-collapse', state);
    },
  },
};
</script>

<style lang="scss" scoped>
  .collapse-height {
    --content-padding-top: 16px;
  }

  .collapse-height__toggler {
    cursor: pointer;
  }

  .collapse-height__content {
    padding-top: var(--content-padding-top);
  }

</style>
